const styles = theme => {
  return {
    container: {
      display: 'block',
    },
    field: {
      '& .MuiOutlinedInput-root': {
        fontSize: '12px',
        background: theme.palette.primary.white,
        borderRadius: 0,
        transition: `all 0.1s`,
        '& .MuiOutlinedInput-input': {
          borderRadius: 0,
          padding: '17.5px 14px !important',
        },
        '& fieldset': {
          transition: `all 0.4s`,
          border: '1px solid #CED1D6 !important',
        },
        '&:hover fieldset': {
          boxShadow: theme.shadows[1],
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #342D3D !important',
          boxShadow: theme.shadows[1],
        },
        '& [value="Success"] + fieldset': {
          borderColor: '#12B78E !important',
        },
      },
      [theme.breakpoints.up('sm')]: {
        '& .MuiOutlinedInput-root': {
          fontSize: '14px',
        },
      },
      [theme.breakpoints.up('md')]: {
        '& .MuiOutlinedInput-root': {
          fontSize: '16px',
        },
      },
    },
    fieldTextArea: {
      width: '100%',
      padding: '18px 14px',
      border: '1px solid #CED1D6',
      borderRadius: 0,
      minHeight: '120px',
      fontSize: '12px',
      outline: 'none',
      '&:hover': {
        transition: `all 0.4s`,
        boxShadow: theme.shadows[1],
      },
      '&:focus': {
        transition: `all 0.4s`,
        border: '1px solid #342D3D',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '16px',
      },
      '&::placeholder': {
        color: theme.palette.primary.dim,
      },
    },
    errorField: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid #EA4633 !important',
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #EA4633 !important',
        },
      },
    },
    errorFieldTextArea: {
      border: '1px solid #EA4633 !important',
    },
    sucessField: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid #12B78E !important',
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #EA412B78E633 !important',
        },
      },
    },
    preFilledField: {
      '& .MuiOutlinedInput-root': {
        background: theme.palette.primary.borderColor,
        color: theme.palette.primary.dim,
      },
    },
    label: {
      color: theme.palette.primary.adgmBlack,
      marginBottom: '4px',
      fontWeight: 500,
      fontSize: '12px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '16px',
      },
    },
    textADGMRed: {
      color: theme.palette.primary.darkErrorRed,
    },
    errorMsg: {
      color: theme.palette.primary.errorRed,
      fontSize: '12px',
      marginLeft: '5px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },
    sucessMsg: {
      color: '#12B78E',
      fontSize: '12px',
      marginLeft: '5px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },

    disabled: {
      '& > .MuiInputBase-root': {
        background: theme.palette.primary.borderColor,
      },
    },
  };
};

export default styles;
